import { render, staticRenderFns } from "./assestInvoice.vue?vue&type=template&id=1cf36598&scoped=true"
import script from "./assestInvoice.vue?vue&type=script&lang=js"
export * from "./assestInvoice.vue?vue&type=script&lang=js"
import style0 from "./assestInvoice.vue?vue&type=style&index=0&id=1cf36598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf36598",
  null
  
)

export default component.exports